module.exports = {
      id: "carteira-transacao-error-usage",
      viewBox: "0 0 97 75",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#carteira-transacao-error",
      toString: function () {
        return this.url;
      }
    }